import {
  CreateReportRequest,
  CreateWorkspaceRequest,
  EditReportRequest,
  EditWorkspaceRequest,
  EmbedReportRequest,
  HierarchyLevels,
  ShareReportCodeRequest,
  ShareReportEmailRequest,
  StoreUserHierarchyRequest
} from 'api/NSwagApi/api';
import { inSightApi } from 'api/NSwagApi/inSight-runtime'

export const useInsightApi = () => {
  const allWorkspaces = async () => {
      return inSightApi.workspaces_GetAllWorkspaces();
  }

  const createWorkspaces = async (createWorkspaceRequest:CreateWorkspaceRequest) => {
      return inSightApi.workspaces_CreateWorkspace(createWorkspaceRequest);
  }

  const editWorkspaces = async (editWorkspaceCommand:EditWorkspaceRequest) => {
      return inSightApi.workspaces_EditWorkspacePOST(editWorkspaceCommand);
  }

  const editGetWorkspaces = async (workspacesId:string) => {
    return inSightApi.workspaces_EditWorkspaceGET(workspacesId);
  }

  const getAllReports = async (workspacesId:string) => {
      return inSightApi.workspaces_GetWorkspace(workspacesId);
  }

  const createReport = async (createReportRequest:CreateReportRequest) => {
      return inSightApi.reports_Create(createReportRequest);
  }

  const editReport = async (reportId:string, EditReportRequest:EditReportRequest) => {
      return inSightApi.reports_Edit(reportId, EditReportRequest)
;  }

  const fetchUnregisteredApplicationsList = async () => {
    return inSightApi.applications_GetUnregisteredApplications();
  }

  const fetchRegisteredApplicationsList = async () => {
    return inSightApi.applications_GetRegisteredApplicationList();
  }

  const fetchActiveApplicationsList = async () => {
    return inSightApi.applications_GetActiveRegisteredApplicationList();
  }

  const getRegisteredApplicationById = async (registeredAppId: string) => {
    return inSightApi.applications_GetRegisteredApplication(registeredAppId);
  }

  const registerApplication = async (registerApplicationDto : FormData) => {
    return inSightApi.applications_RegisterApplication(registerApplicationDto);
  }

  const editRegisteredApplication = async (editApplicationDto: FormData) => {
    return inSightApi.applications_EditRegisteredApplication(editApplicationDto);
  }

  const getApplicationSystemAudit = async () => {
    return inSightApi.applications_GetApplicationSystemAudit();
  }

  const reportsGetClientReportsForApplication = async (applicationId: string, clientId: string, engagementId: string) => {
    return inSightApi.reports_GetClientReportsForApplication(applicationId, clientId, engagementId)
  }

  const reportsGetUserCentricReportsForApplication = async (applicationId: string) => {
    return inSightApi.reports_GetUserCentricReportsForApplication(applicationId);
  }

  const reportsToggleFavorite = async (reportId: string) => {
    return inSightApi.reports_ToggleFavorite(reportId);
  }

  const shareReportCode = async (shareReportCodeRequest: ShareReportCodeRequest) => {
    return inSightApi.reports_ShareReportCode(shareReportCodeRequest);
  }

  const shareReportEmail = async (shareReportEmailRequest: ShareReportEmailRequest) => {
    return inSightApi.reports_ShareReportEmail(shareReportEmailRequest);
  }

  const reportsGetSharedReportCode = async (code: string) => {
    return inSightApi.reports_GetSharedReportCode(code);
  }

  const reportsGetReport = async (reportId: string) => {
    return inSightApi.reports_GetReport(reportId);
  }

  const reportsGetHierarchyStructure = async (reportId: string, workspaceId: string) => {
    return inSightApi.reports_GetHierarchyStructure(workspaceId, reportId);
  }

  const reportsGetEmbeddedUrl = async (reportId: string, request: EmbedReportRequest) => {
    return inSightApi.reports_Get(reportId, request);
  }

  const getReportsAudit = async () => {
    return inSightApi.reports_GetReportsAudit();
  }

  const getReportSystemAudit = async () => {
    return inSightApi.reports_GetReportsSystemAudit();
  }

  const getReportClientAdminAudit = async (applicationId: string, clientId: string) => {
    return inSightApi.reports_GetReportsClientAdminAudit(applicationId, clientId);
  }

  const getUserReportsAudit = async (applicationId: string) => {
    return inSightApi.reports_GetReportsUserCentricAudit(applicationId);
  }

  const getClientsForUserReports = async (applicationId: string) => {
    return inSightApi.reports_GetClientsForUserReports(applicationId);
  }
  const getEngagementsForUserReports = async (applicationId: string, clientId: string) => {
    return inSightApi.reports_GetEngagementsForUserReports(applicationId, clientId);
  }

  const getFeatureTypes = async () => {
    return inSightApi.features_Get();
  }

  const getClientAssignments = async (applicationId: string) => {
    return inSightApi.assignments_GetClientAssignments(applicationId);
  }

  const getEngagementAssignments = async (applicationId: string, clientId: string) => {
    return inSightApi.assignments_GetEngagementAssignments(applicationId, clientId);
  }

  const getProjectAssignments = async (applicationId: string, clientId: string | undefined, engagementIds: string | undefined) => {
    return inSightApi.assignments_GetProjectAssignments(applicationId, clientId, engagementIds);
  }

  const getEntityAssignments = async (applicationId: string, hierarchyLevel: HierarchyLevels, parentHierarchyId: string) => {
    return inSightApi.assignments_GetEntityAssignments(applicationId, hierarchyLevel, parentHierarchyId);
  }

  const getJobAssignments = async (applicationId: string, hierarchyLevel: HierarchyLevels, parentHierarchyId: string) => {
    return inSightApi.assignments_GetJobAssignments(applicationId, hierarchyLevel, parentHierarchyId);
  }

  const checkIfClientAdmin = async (applicationId: string) => {
    return inSightApi.assignments_CheckIfClientAdmin(applicationId);
  }

  const getClientsForAdmin = async (applicationId: string|undefined) => {
    return inSightApi.assignments_getClientsForAdmin(applicationId);
  }

  const getRoleFeatures = async (applicationId: string) => {
    return inSightApi.assignments_GetRoleFeatures(applicationId);
  }

  const getApplicationActiveUsers = async (applicationId: string) => {
    return inSightApi.assignments_GetApplicationActiveUsers(applicationId);
  }

  const storeUserSelections = async(userSelectionDto : StoreUserHierarchyRequest) => {
    return inSightApi.userSelection_StoreUserHierarchy(userSelectionDto);
  }

  const getUserSelections = async() => {
    return inSightApi.userSelection_GetUserHierarchy();
  }

  const clearUserHierarchySelections = async() => {
    return inSightApi.userSelection_ClearSelection();
  }

  const workspaceGetReportsWithAudit = async (workspacesId:string) => {
    return inSightApi.workspaces_GetReportsWithAudit(workspacesId);
  }

  const getWorkspaceSystemAudit = async () => {
    return inSightApi.workspaces_GetWorkspaceSystemAudit();
  }

  return {
    allWorkspaces,
    fetchRegisteredApplicationsList,
    fetchUnregisteredApplicationsList,
    fetchActiveApplicationsList,
    getRegisteredApplicationById,
    registerApplication,
    editRegisteredApplication,
    getApplicationSystemAudit,
    getClientsForUserReports,
    getEngagementsForUserReports,
    createReport,
    createWorkspaces,
    editGetWorkspaces,
    editReport,
    editWorkspaces,
    getAllReports,
    reportsGetClientReportsForApplication,
    reportsGetUserCentricReportsForApplication,
    reportsToggleFavorite,
    shareReportCode,
    shareReportEmail,
    reportsGetSharedReportCode,
    reportsGetReport,
    getReportsAudit,
    getReportSystemAudit,
    getReportClientAdminAudit,
    getUserReportsAudit,
    getClientsForAdmin,
    checkIfClientAdmin,
    getRoleFeatures,
    getApplicationActiveUsers,
    getFeatureTypes,
    reportsGetHierarchyStructure,
    reportsGetEmbeddedUrl,
    getClientAssignments,
    getEngagementAssignments,
    getProjectAssignments,
    getEntityAssignments,
    getJobAssignments,
    storeUserSelections,
    getUserSelections,
    clearUserHierarchySelections,
    workspaceGetReportsWithAudit,
    getWorkspaceSystemAudit
  }
}